// extracted by css-extract-rspack-plugin
export default {"StrengthIndicator":"AEOiq"};